import api from '@/utils/api'

import eventsBus from '@/components/shared/EventsBus'

const actions = {
  deletePoll (ctx, poll) {
    return api.delete('poll/' + poll.id).then((response) => {
      eventsBus.$emit(eventsBus.DELETED_POLL, {poll: poll})
      return response
    })
  },
  getPoll (ctx, id) {
    return new Promise((resolve, reject) => {
      api.get(`/poll/${id}`).then((response) => {
        resolve(response.data)
      }).catch(() => {
        reject()
      })
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/polls.js